const Photo = ({ image }) => {
    return (
        <div className="imagePhoto">
            <img className="image-fluid" src={image} />
        </div>
    )
}

export default Photo